import { render, staticRenderFns } from "./PerformanceImprovementDetails.vue?vue&type=template&id=5e3332ba&scoped=true"
import script from "./PerformanceImprovementDetails.vue?vue&type=script&lang=js"
export * from "./PerformanceImprovementDetails.vue?vue&type=script&lang=js"
import style0 from "./PerformanceImprovementDetails.vue?vue&type=style&index=0&id=5e3332ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3332ba",
  null
  
)

export default component.exports